var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightbulbBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 512",
    style: {
      enableBackground: "new 0 0 384 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4795FB;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272,384c9.6-31.9,29.5-59.1,49.2-86.2l0,0c5.2-7.1,10.4-14.2,15.4-21.4c19.8-28.5,31.4-63,31.4-100.3 C368,78.8,289.2,0,192,0S16,78.8,16,176c0,37.3,11.6,71.9,31.4,100.3c5,7.2,10.2,14.3,15.4,21.4l0,0c19.8,27.1,39.7,54.4,49.2,86.2 h160V384z M192,512c44.2,0,80-35.8,80-80v-16H112v16C112,476.2,147.8,512,192,512z M112,176c0,8.8-7.2,16-16,16s-16-7.2-16-16 c0-61.9,50.1-112,112-112c8.8,0,16,7.2,16,16s-7.2,16-16,16C147.8,96,112,131.8,112,176z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbBlue);
export default __webpack_public_path__ + "static/media/lightbulb-blue.698b77a167b0b9bc637f7104371298c5.svg";
export { ForwardRef as ReactComponent };